export function orderStrategies(all: string[], preferred: string[]) {
  const available = new Set(all);
  const first = preferred.filter((strategy, index) =>
    available.has(strategy) && preferred.indexOf(strategy) === index);
  return [...first, ...all.filter((strategy) => !first.includes(strategy))];
}
